import React from 'react';
import { FormattedMessage } from 'react-intl';

export const GATE_SELECT = 'gate-select';
export const GATE_DETAILS = 'gate-details';
export const GATE_DASHBOARD = 'gate-dashboard';
export const GATE_RELAY_SELECT_ID = 'gate-relay-select';
export const GATE_RELAY_SOURCE = 'relays-select';
export const CAMERA_GATE_SELECT_ID = 'camera-details-gate-select';

export const OPENING_METHODS = {
  PIN_CODE: 'PIN_CODE',
  QR_CODE: 'QR_CODE',
  RELAY: 'RELAY',
};

export const OPENING_METHODS_LABEL = {
  [OPENING_METHODS.PIN_CODE]: (
    <FormattedMessage id="gate.openingMethod.pin_code" defaultMessage="Pin code" />
  ),
  [OPENING_METHODS.QR_CODE]: (
    <FormattedMessage id="gate.openingMethod.qr_code" defaultMessage="QR code" />
  ),
  [OPENING_METHODS.RELAY]: (
    <FormattedMessage id="gate.openingMethod.relay" defaultMessage="Relay" />
  ),
};

export const OPENING_METHODS_OPTIONS = Object.entries(OPENING_METHODS_LABEL).map(([mode, label]) => ({
  value: mode,
  label,
}));

export const GATE_STATUS_ENUM = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};
